import {Component, Inject} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogModule,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';
import {TranslocoPipe} from '@jsverse/transloco';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'request-maintenance-policy-dialog',
  imports: [
    CommonModule,
    MatDialogModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    TranslocoPipe
  ],
  standalone: true,
  templateUrl: './request-maintenance-policy-dialog.component.html',
})
export class RequestMaintenancePolicyDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<RequestMaintenancePolicyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }
}
